
export interface ExtraFieldOption {
  value: string;
  uuid?: string;
}

export const EXTRA_FIELD_VALUE_TYPES = {
  BOOL: 'bool',
  NUMBER: 'number',
  NUMBER_RANGE: 'number_range',
  TEXT: 'text',
  TEXTAREA: 'textarea',
  SELECT: 'select',
  MULTI_SELECT: 'multi_select',
  DATE: 'date',
  JSON: 'json',
}
export interface ExtraFieldType {
  id?: string;
  isNew?: boolean;
  label: string;
  slug?: string;
  description?: string;
  related_to: 'lead' | 'serviceRequest' | 'customer';
  field_type: (typeof EXTRA_FIELD_VALUE_TYPES)[keyof typeof EXTRA_FIELD_VALUE_TYPES];
  options?: ExtraFieldOption[];
  is_editable: boolean;
}
